import { Box } from "@mui/material";
import { memo } from "react";

const Divider = ({ isHorizontal }) => isHorizontal ?
  <Box
    sx={{
      height: '1px',
      alignSelf: 'stretch',
      background: '#e2e8f0',
      flexShrink: 0,
      width: "100%"
    }}
  />
  : (
    <Box
      sx={{
        width: '1px',
        alignSelf: 'stretch',
        background: '#e2e8f0',
        flexShrink: 0,
      }}
    />
  );

export default memo(Divider)